module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-learn-site-thumbnail_ja-8e979b9558be389d178b409259fa0616.png";